import { Static, Type } from '@sinclair/typebox';

export const ServiceStatusResponseSchema = Type.Object({
  has_active_incident: Type.Boolean(),
  active_incidents: Type.Array(
    Type.Object({
      title: Type.String(),
      status: Type.String(),
    }),
  ),
});

export type ServiceStatusResponse = Static<typeof ServiceStatusResponseSchema>;
